import { render, staticRenderFns } from "./Colorization.vue?vue&type=template&id=6793da17&scoped=true&"
import script from "./Colorization.vue?vue&type=script&lang=js&"
export * from "./Colorization.vue?vue&type=script&lang=js&"
import style0 from "./Colorization.vue?vue&type=style&index=0&id=6793da17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6793da17",
  null
  
)

export default component.exports